import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all_with_count, fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
import { currentPracticeAtom } from '../../../lib/practice';

import AttachFileIcon from '@mui/icons-material/AttachFile';
import BookIcon from '@mui/icons-material/Book';
import CreditCardOffIcon from '@mui/icons-material/CreditCardOff';
import EuroIcon from '@mui/icons-material/Euro';
import PointOfSale from '@mui/icons-material/PointOfSale';
import SchoolIcon from '@mui/icons-material/School';
import TvIcon from '@mui/icons-material/Tv';
import Wc from '@mui/icons-material/Wc';
import LocationCity from '@mui/icons-material/LocationCity';

import Logo from '../../../images/logo_nutriportal2024.png';

import {
  Alert,
  Avatar,
  Box,
  CardContent,
  CircularProgress,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tab,
  Tabs,
} from '@mui/material';

import {
  Button,
  DataGrid,
  Dt,
  Fab,
  IconButton,
  Page,
  TextInput,
  Typography
} from '../../../components/v2/styled';
import { SearchBox } from '../../../components/v2/SearchBox';
import { SnackDestroyed } from '../../../components/v2/snacks/Destroyed';

import { KnowledgeCourse } from '../../../models/KnowledgeCourse';

import HelpersLanguage from '../../../actions/helpers/language';
import { CardCourse } from '../../../components/v2/cards/Course';
import { CardBase } from '../../../components/v2/cards/Base';
import { StyledKnowledgeSubject } from '../../../components/v2/styled/knowledge/Subject';
import Person from '@mui/icons-material/Person';
import Cake from '@mui/icons-material/Cake';
import Public from '@mui/icons-material/Public';
import LocalOffer from '@mui/icons-material/LocalOffer';
import Info from '@mui/icons-material/Info';
import Beenhere from '@mui/icons-material/Beenhere';

const { DateTime } = require("luxon");

type Props = {}

export const ClientKnowledgeCourseDetail: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  const params = useParams();

  const [objectId, setObjectId] = useState<string | undefined>(params.id);
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("created_at DESC");
  const [search, setSearch] = useState<string>("");
  const [videoActiveLanguage, setVideoActiveLanguage] = useState<string>(i18n.resolvedLanguage || 'nl');
  const [currentTab, setCurrentTab] = useState<number>(0);
  const [showCoupon, setShowCoupon] = useState<boolean>(false);
  const [activeCoupon, setActiveCoupon] = useState<string>("");
  const [showCouponError, setShowCouponError] = useState<boolean>(false);

  const [destroyedOpen, setDestroyedOpen] = useState<boolean>(false);

  const {
    data: object,
    isLoading: objectLoading,
    isError: objectError,
    isSuccess: objectSuccess,
    refetch: objectRefetch,
  } = useQuery({
    queryKey: ["client", "knowledge_course", objectId, {page: page, order: order, search: search}],
    queryFn: () =>
      fetch_one<KnowledgeCourse>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'knowledge_course',
          fields: [
            'id', 'full_name', 'full_teaser', 'full_body', 'extra_data', 'get_item', 'is_bg_color', 'practice', 
            'knowledge_subjects', 'knowledge_lessons', 'access_data', 'mollie_data', 'knowsub', 'is_nutri', 'is_it',
            'segment_explanation', 'course_type'
          ],
          sub_fields: {
            practice: ['id', 'name', 'get_item', 'get_medium'],
            knowledge_subjects: ['id', 'full_name', 'full_body', 'knowledge_lessons', 'extra_data'],
            knowledge_lessons: ['id', 'full_name', 'videos', 'attachments', 'is_video_lesson'],
            knowsub: ['id', 'created_at', 'lesson_key', 'is_approved', 'mollie_link', 'mollie_data'],
            mollie_link: ['id', 'paid', 'extra_data']
          },
          id: objectId
        },
        login
      ),
    enabled: !!login?.id && !!objectId,
  });

  // const {
  //   data: objects,
  //   isLoading: objectsLoading,
  //   isError: objectsError,
  //   isSuccess: objectsSuccess,
  //   refetch: objectsRefetch,
  // } = useQuery({
  //   queryKey: ["client", "knowledge_courses", (login?.id), {page: page, order: order, search: search}],
  //   queryFn: () =>
  //     fetch_all_with_count<KnowledgeCourse>(
  //       `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
  //       {
  //         object: 'knowledge_course',
  //         fields: ['id', 'full_name', 'full_teaser', 'extra_data', 'get_item', 'is_bg_color', 'practice'],
  //         sub_fields: {
  //           practice: ['id', 'name', 'get_item']
  //         },
  //         order: order,
  //         per_page: 20,
  //         page: page,
  //         filter: {
  //           search: search,
  //           advanced: {
  //             for_client: login?.id
  //           }
  //         }
  //       },
  //       login
  //     ),
  //   select: (d) => {
  //     // count = d.count;
  //     return d.result;
  //   },
  //   enabled: !!(login?.practice_id || currentPractice?.id),
  // });







  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<{custom_result: {success?: boolean;}}>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setActiveCoupon('');
      setShowCoupon(false);
      objectRefetch();
      setCurrentTab(1);
    },
  });
  // const mutationDestroy = useMutation({
  //   mutationFn: (pars: {
  //     formData: any;
  //   }) => {
  //     return fetch_one<KnowledgeCourse>(
  //       `/${i18n.resolvedLanguage || 'nl'}/v3/objects/remove`,
  //       pars.formData,
  //       login
  //     );
  //   },
  //   onMutate: (pars: {
  //     formData: any;
  //   }) => {
  //     return true;
  //   },
  //   onError: (data, variables, context) => {
  //     return true;
  //   },
  //   onSuccess: (data, variables, context) => {
  //     setDestroyedOpen(true);
  //     objectsRefetch();
  //   },
  // });







  const selectContentWithId = (field?:{[z:string]: string}, extraFallback?:string) => {
    let correct = (field || {})[HelpersLanguage.mapping_to_id(i18n.resolvedLanguage || 'nl')];
    if (!!correct) return correct;
    let fallback = (field || {})['nl'];
    if (!!fallback) return fallback;
    let anyFallback = Object.values(field || {}).filter(fff => !!fff)[0];
    if (!!anyFallback) return anyFallback;
    if (!!extraFallback) return extraFallback;
    return t("general.translation_fallbacks.no_translation_available")
  }

  useEffect(() => {
    if (params.id !== 'new') objectRefetch();
  }, [params.id]);

  return <Page
    title={selectContentWithId(object?.full_name || {})}
    titleCrumbs={[
      {
        title: t("client.menu.knowledge_center"),
        path: "/knowledge_center"
      }
    ]}
  >
    <Grid container spacing={1}>
      {!!object?.knowsub && <Grid item xs={12}>
        <Box sx={{
          marginBottom: 3,
          '& .Mui-selected': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)'
          }
        }}>
          <Tabs
            value={currentTab}
            onChange={(e, v) => {setCurrentTab(v);}}
            indicatorColor="primary"
            textColor="primary"
            aria-label="Tabs"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              position: 'relative',
              zIndex: 1202
            }}
          >
            <Tab icon={<Info />} label={t("general.knowledge_courses.detail_tab.information")} />
            <Tab icon={<Beenhere />} label={t("general.knowledge_courses.detail_tab.sub_info")} />
          </Tabs>
          <Divider sx={{borderColor: theme.palette.primary.main}} />
        </Box>
      </Grid>}

      
      {currentTab === 0 && <Grid item xs={12} md={8}>
{/* video */}
        {Object.values(object?.extra_data?.video_url || {}).filter(fff => !!fff).length > 0 && <CardBase sx={{height: 'auto', marginBottom: 2}}>
          <CardContent>
            <video id="video" controls style={{objectFit: 'contain', width: '100%'}}>
              <source src={`${(object?.extra_data?.video_url || {})[videoActiveLanguage]}?${videoActiveLanguage}`} type="video/mp4"/>
            </video>
            <Typography sx={{
              textDecoration: 'underline'
            }}>{t("client.course.subtitles.video_available_in")}</Typography>
            <Box sx={{
              height: '40px',
              display: 'flex',
              flexDirection: 'row'
            }}>
              {Object.keys(object?.extra_data?.video_url || {}).filter(fff => !!(object?.extra_data?.video_url || {})[fff]).map(l => <Avatar
                sx={{
                  backgroundColor: l === videoActiveLanguage ? theme.palette.primary.main : 'white',
                  color: l === videoActiveLanguage ? 'white' : theme.palette.primary.main,
                  border: '1px solid white',
                  borderColor: l === videoActiveLanguage ? 'white' : theme.palette.primary.main,
                  marginRight: 1,
                  cursor: 'pointer'
                }}
                onClick={() => {
                  setVideoActiveLanguage(l);
                  var video = document.getElementById('video');
                  // @ts-ignore
                  video.load();
                }}
              >
                {l}
              </Avatar>)}
            </Box>
          </CardContent>
        </CardBase>}

        <CardBase sx={{height: 'auto'}}>
          <CardContent>
            <Typography sx={{
              color: theme.palette.tertiary?.main,
              marginBottom: 1,
              fontWeight: 'bold'
            }}>{t("client.course_readmore.titles.summary")}</Typography>
            <Divider />

            <Typography html clean>{selectContentWithId(object?.full_body || {})}</Typography>
          </CardContent>
        </CardBase>

        <CardBase sx={{height: 'auto', marginTop: 2}}>
          <CardContent>
            <Typography sx={{
              color: theme.palette.tertiary?.main,
              marginBottom: 1,
              fontWeight: 'bold'
            }}>{t("client.course_readmore.titles.chapters")}</Typography>
            <Divider sx={{marginBottom: 2}} />

            {!!object && (object?.knowledge_subjects || []).map((subject, i) => <>
              <StyledKnowledgeSubject
                knowledgeCourse={object}
                knowledgeSubject={subject}
                i={i}
                collapseLessons
              />
            </>)}
          </CardContent>
        </CardBase>
      </Grid>}
      {currentTab === 1 && <Grid item xs={12} md={8}>
        <Typography html>{t("client.course_betweenpage.generic_part")}</Typography>
        {!!object?.is_approvable && <Typography sx={{marginTop: 2}} html>{t("client.course_betweenpage.approval_flow_part")}</Typography>}
        {!!object?.knowsub?.mollie_link?.extra_data?.mollie?.payment_link && !object?.knowsub?.mollie_link?.paid && <Typography sx={{marginTop: 2}} html>{t("client.course_betweenpage.payment_part", {link: object?.knowsub?.mollie_link?.extra_data?.mollie?.payment_link})}</Typography>}
        {!!object?.knowsub?.mollie_link?.extra_data?.mollie?.payment_link && !!object?.knowsub?.mollie_link?.paid && <Typography sx={{marginTop: 2}} html>{t("client.course_betweenpage.payment_paid_part", {date: DateTime.fromISO(object?.knowsub?.mollie_link?.extra_data?.mollie?.paid_at).toFormat("dd/LL/y t")})}</Typography>}

      </Grid>}

      <Grid item xs={12} md={4}>
        <CardBase sx={{height: 'auto'}}>
          <CardContent sx={{paddingBottom: "16px !important"}}>
            {!object?.knowsub?.id && <Button
              label={t("client.course_readmore.cta_subscribe")}
              id="sub_courses"
              contained
              onClick={() => {
                mutationCustomAction.mutate({
                  formData: {
                    object: 'knowledge_course',
                    class_action: 'custom_api_subscribe',
                    id: object?.id,
                    user_id: login?.id,
                    handler_id: login?.id
                  }
                });
              }}
              sx={{
                marginTop: 0
              }}
              fullwidth
            />}
            {!showCoupon && !!object?.knowsub?.mollie_link && !object?.knowsub?.mollie_link?.paid && <>
              <Button
                label={t("client.course_readmore.cta_afrekenen")}
                id="cta_afrekenen"
                contained
                onClick={() => {
                  window.open(object?.knowsub?.mollie_link?.extra_data?.mollie?.payment_link, "_BLANK");
                }}
                sx={{
                  marginTop: 0,
                  marginBottom: 1
                }}
                fullwidth
              />
            </>}
            {!!object?.knowsub?.mollie_link && !object?.knowsub?.mollie_link?.paid && !!object?.knowsub?.mollie_data?.coupon && <>
              <Alert severity='info'>
                <Typography sx={{
                    fontStyle: 'italic'
                  }}>{t("client.course_readmore.coupon_applied", {coupon: object?.knowsub?.mollie_data?.coupon})}</Typography>
              </Alert>
            </>}
            {!showCoupon && !!object?.knowsub?.mollie_link && !object?.knowsub?.mollie_link?.paid && (object?.mollie_data?.coupons || []).length > 0 && !object?.knowsub?.mollie_data?.coupon && <>
              <Button
                label={t("client.course_readmore.i_have_coupon")}
                id="i_have_coupon"
                text
                onClick={() => {
                  setShowCoupon(true);
                }}
                sx={{
                  marginTop: 0,
                  marginBottom: 1
                }}
                fullwidth
              />
            </>}
            {!!showCoupon && <>
              <TextInput
                id="coupon"
                noCaption
                placeholder={t("general.knowledge_courses.fields.coupon_name")}
                value={activeCoupon || ''}
                onChange={(e) => {
                  setActiveCoupon(e);
                }}
                sx={{
                  marginTop: 0
                }}
              />
              {!!showCouponError && <Alert severity='error' sx={{marginTop: 1}}>
                <Typography sx={{
                  fontStyle: 'italic'
                }}>{t("client.course_readmore.redeem_coupon_error_invalid")}</Typography>
              </Alert>}
              <Button
                label={t("client.course_readmore.redeem_coupon")}
                id="redeem_coupon"
                contained
                onClick={() => {
                  setShowCouponError(false);
                  let foundCoupon = undefined;
                  (object?.mollie_data?.coupons || []).forEach(cpn => {
                    if (cpn.name === activeCoupon && DateTime.fromFormat(cpn.date, "dd/LL/y") >= DateTime.now()) foundCoupon = cpn.perc;
                  });

                  if (!!foundCoupon) {
                    mutationCustomAction.mutate({
                      formData: {
                        object: 'knowledge_subscription',
                        class_action: 'custom_api_apply_coupon',
                        id: object?.knowsub?.id,
                        coupon: activeCoupon
                      }
                    });
                  } else {
                    setShowCouponError(true);
                  }
                }}
                sx={{
                  marginTop: 1,
                  marginBottom: 1
                }}
                fullwidth
              />
              <Button
                label={t("client.course_readmore.cancel_redeem_coupon")}
                id="cancel_coupon"
                text
                onClick={() => {
                  setActiveCoupon('');
                  setShowCoupon(false);
                }}
                sx={{
                  marginTop: 1,
                  marginBottom: 1
                }}
                fullwidth
              />
            </>}
            {!!object?.knowsub?.mollie_link && !object?.knowsub?.mollie_link?.paid && <Typography sx={{
              color: theme.palette.tertiary?.main,
              marginTop: 1,
              textAlign: 'center',
              fontStyle: 'italic',
              marginBottom: 1
            }}>{t("client.course_detail.warning.needs_payment")}</Typography>}
            {!!object?.knowsub?.id && <>
              <Typography sx={{
                color: theme.palette.tertiary?.main,
                marginBottom: 1,
                fontWeight: 'bold',
                textAlign: 'center'
              }}>{t("client.course_detail.headers.subscribed_on")}</Typography>
              <Typography sx={{
                textAlign: 'center'
              }}><Dt d={object?.knowsub?.created_at} /></Typography>
              <Button
                label={t(object?.course_type === 1 ? "client.course_readmore.goto_knowledge" : "client.course_readmore.goto_lesson")}
                id="goto_lesson"
                disabled={!object?.knowsub?.is_approved}
                contained
                onClick={() => {
                  navigate(`/knowledge_subscription/${object?.knowsub?.lesson_key}`);
                }}
                sx={{
                  marginTop: 2
                }}
                fullwidth
              />
              {((!!object?.knowsub?.mollie_link && !!object?.knowsub?.mollie_link?.paid || !object?.knowsub?.mollie_link) && !object?.knowsub?.is_approved) && <Typography sx={{
                color: theme.palette.tertiary?.main,
                marginTop: 1,
                textAlign: 'center',
                fontStyle: 'italic'
              }}>{t("client.course_detail.warning.needs_approval")}</Typography>}
            </>}
          </CardContent>
        </CardBase>
        <CardBase sx={{height: 'auto', marginTop: 2}}>
          <CardContent>
            <Typography sx={{
              color: theme.palette.tertiary?.main,
              marginBottom: 1,
              fontWeight: 'bold'
            }}>{t("client.course_readmore.titles.made_by")}</Typography>
            <Divider />

            <List sx={{
              "& li": {
                paddingBottom: 0.5,
                paddingTop: 0.5
              }
            }}>
              {!!object?.is_nutri && <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{
                    backgroundColor: 'white',
                    border: '1px solid transparent',
                    borderColor: theme.palette.primary.main,
                    "& img": {
                      maxHeight: '100%',
                      maxWidth: '100%',
                      width: 'auto',
                      height: 'auto'
                    }
                  }} src={Logo} alt={t("general.terms.nutriportal")}></Avatar>
                </ListItemAvatar>
                <ListItemText primary={t("general.terms.nutriportal")} />
              </ListItem>}
              {!!object?.is_it && <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{
                    backgroundColor: 'white',
                    border: '1px solid transparent',
                    borderColor: theme.palette.primary.main,
                    "& img": {
                      maxHeight: '100%',
                      maxWidth: '100%',
                      width: 'auto',
                      height: 'auto'
                    }
                  }} src={Logo} alt={t("general.terms.it_team")}></Avatar>
                </ListItemAvatar>
                <ListItemText primary={t("general.terms.it_team")} />
              </ListItem>}
              {!object?.is_nutri && !object?.is_it && <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{
                    backgroundColor: 'white',
                    border: '1px solid transparent',
                    borderColor: theme.palette.primary.main,
                    "& img": {
                      maxHeight: '100%',
                      maxWidth: '100%',
                      width: 'auto',
                      height: 'auto'
                    }
                  }} src={object?.practice?.get_medium} alt={object?.practice?.name}></Avatar>
                </ListItemAvatar>
                <ListItemText primary={object?.practice?.name} />
              </ListItem>}
            </List>
            <Typography sx={{
              color: theme.palette.tertiary?.main,
              marginBottom: 1,
              fontWeight: 'bold'
            }}>{t(object?.course_type === 1 ? "client.course_readmore.knowledge_titles.about" : "client.course_readmore.titles.about")}</Typography>
            <Divider />

            <List sx={{
              "& li": {
                paddingBottom: 0.5,
                paddingTop: 0.5
              }
            }}>
              <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{
                    backgroundColor: 'white',
                    border: '1px solid transparent',
                    borderColor: theme.palette.primary.main,
                    "& img": {
                      maxHeight: '100%',
                      maxWidth: '100%',
                      width: 'auto',
                      height: 'auto'
                    }
                  }}>
                    <BookIcon color="primary" />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={`${(object?.knowledge_subjects?.length || 0)} ${t(`client.course_readmore.stats.chapters_${(object?.knowledge_subjects?.length || 0) === 1 ? 'single' : 'multi'}`)}`} />
              </ListItem>
              {((object?.knowledge_lessons || []).filter(fff => !!fff.is_video_lesson).length || 0) > 0 && <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{
                    backgroundColor: 'white',
                    border: '1px solid transparent',
                    borderColor: theme.palette.primary.main,
                    "& img": {
                      maxHeight: '100%',
                      maxWidth: '100%',
                      width: 'auto',
                      height: 'auto'
                    }
                  }}>
                    <TvIcon color="primary" />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={`${((object?.knowledge_lessons || []).filter(fff => !!fff.is_video_lesson).length || 0)} ${t(`client.course_readmore.${object?.course_type === 1 ? "knowledge_" : ""}stats.lesson_video_${((object?.knowledge_lessons || []).filter(fff => !!fff.is_video_lesson).length || 0) === 1 ? 'single' : 'multi'}`)}`} />
              </ListItem>}
              {((object?.knowledge_lessons || []).filter(fff => !fff.is_video_lesson).length || 0) > 0 && <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{
                    backgroundColor: 'white',
                    border: '1px solid transparent',
                    borderColor: theme.palette.primary.main,
                    "& img": {
                      maxHeight: '100%',
                      maxWidth: '100%',
                      width: 'auto',
                      height: 'auto'
                    }
                  }}>
                    <SchoolIcon color="primary" />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={`${((object?.knowledge_lessons || []).filter(fff => !fff.is_video_lesson).length || 0)} ${t(`client.course_readmore.${object?.course_type === 1 ? "knowledge_" : ""}stats.lesson_text_${((object?.knowledge_lessons || []).filter(fff => !fff.is_video_lesson).length || 0) === 1 ? 'single' : 'multi'}`)}`} />
              </ListItem>}
              {(object?.knowledge_lessons || []).reduce((acc, cur) => acc + Object.values(cur.attachments || {}).reduce((aacc, ccur) => aacc + (ccur || []).length, 0), 0) > 0 && <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{
                    backgroundColor: 'white',
                    border: '1px solid transparent',
                    borderColor: theme.palette.primary.main,
                    "& img": {
                      maxHeight: '100%',
                      maxWidth: '100%',
                      width: 'auto',
                      height: 'auto'
                    }
                  }}>
                    <AttachFileIcon color="primary" />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={`${(object?.knowledge_lessons || []).reduce((acc, cur) => acc + Object.values(cur.attachments || {}).reduce((aacc, ccur) => aacc + (ccur || []).length, 0), 0)} ${t(`client.course_readmore.stats.attachment_${(object?.knowledge_lessons || []).reduce((acc, cur) => acc + Object.values(cur.attachments || {}).reduce((aacc, ccur) => aacc + (ccur || []).length, 0), 0) === 1 ? 'single' : 'multi'}`)}`} />
              </ListItem>}
              <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{
                    backgroundColor: 'white',
                    border: '1px solid transparent',
                    borderColor: theme.palette.primary.main,
                    "& img": {
                      maxHeight: '100%',
                      maxWidth: '100%',
                      width: 'auto',
                      height: 'auto'
                    }
                  }}>
                    {!!object?.mollie_data?.cost && parseFloat(object?.mollie_data?.cost) > 0 && <EuroIcon color="primary" />}
                    {!(!!object?.mollie_data?.cost && parseFloat(object?.mollie_data?.cost) > 0) && <CreditCardOffIcon color="primary" />}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={`${t(`client.course_readmore.${object?.course_type === 1 ? "knowledge_" : ""}stats.cost_${!!object?.mollie_data?.cost && parseFloat(object?.mollie_data?.cost) > 0 ? 'paying' : 'free'}`, {cost: object?.mollie_data?.cost})}`} />
              </ListItem>
              {parseInt(object?.mollie_data?.immediate_payment?.toString() || '0', 10) === 1 && <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{
                    backgroundColor: 'white',
                    border: '1px solid transparent',
                    borderColor: theme.palette.primary.main,
                    "& img": {
                      maxHeight: '100%',
                      maxWidth: '100%',
                      width: 'auto',
                      height: 'auto'
                    }
                  }}>
                    <PointOfSale color="primary" />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={`${t(`client.course_readmore.stats.immediate_payment_required`)}`} />
              </ListItem>}
            </List>
            <Divider />
            <Box sx={{
              padding: 1,
              position: 'relative',
              height: '56px'
            }}>
              {(object?.access_data?.availability || [1]).map((lang_id, i) => <Avatar sx={{
                position: 'absolute',
                top: 8,
                left: (16 + (i * 30)),
                backgroundColor: theme.palette.primary.main,
                border: '1px solid white',
                zIndex: 1201 - i
              }}>
                {HelpersLanguage.mapping_to_iso(lang_id)}
              </Avatar>)}
              
            </Box>
          </CardContent>
        </CardBase>
        {(object?.segment_explanation || []).length > 0 && <CardBase sx={{height: 'auto', marginTop: 2}}>
          <CardContent>
            <Typography sx={{
              color: theme.palette.tertiary?.main,
              marginBottom: 1,
              fontWeight: 'bold'
            }}>{t("client.course_readmore.titles.segment_detail")}</Typography>
            <Divider />

            <List sx={{
              "& li": {
                paddingBottom: 0.5,
                paddingTop: 0.5
              }
            }}>
              {(object?.segment_explanation || []).map(segment_line => <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{
                    backgroundColor: 'white',
                    border: '1px solid transparent',
                    borderColor: theme.palette.primary.main,
                    "& img": {
                      maxHeight: '100%',
                      maxWidth: '100%',
                      width: 'auto',
                      height: 'auto'
                    }
                  }}>
                    {segment_line.key === "general.segments.explain.user_type" && <Person color="primary" />}
                    {segment_line.key === "general.segments.explain.age_equals" && <Cake color="primary" />}
                    {segment_line.key === "general.segments.explain.age_between" && <Cake color="primary" />}
                    {segment_line.key === "general.segments.explain.gender" && <Wc color="primary" />}
                    {segment_line.key === "general.segments.explain.country" && <Public color="primary" />}
                    {segment_line.key === "general.segments.explain.zip" && <LocationCity color="primary" />}
                    {segment_line.key === "general.segments.explain.usertag" && <LocalOffer color="primary" />}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={t(segment_line.key, (segment_line.replacers || {}))} />
              </ListItem>)}
            </List>
          </CardContent>
        </CardBase>}
      </Grid>
    </Grid>
  </Page>;
}
